import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import PdfIcon from 'components/atoms/icons/pdfIcon';
import withLoader from 'components/organisms/withLoader';
import common from 'constants/common';
import { convertSecondsToTime } from 'utils/timeHelper';

const CcmInteractiveTime = ({ patientGuid }) => {
  const interactiveTimeLoading = useSelector(
    (state) => state.loading.effects.ccmPatientDetails.getInteractiveTime,
  );

  const interactiveTime = useSelector(
    (state) => state.ccmPatientDetails.interactiveTime,
  );

  const {
    ccmPatientDetails: { getInteractiveTime },
  } = useDispatch();

  useEffect(() => {
    getInteractiveTime(patientGuid);
  }, [patientGuid]);

  return (
    <div className="interactive-time">
      {withLoader(
        interactiveTimeLoading,
        <>
          <div className="interactive-time-header">
            <h3>Interactive Time</h3>
            <PdfIcon />
          </div>
          <div className="interactive-time-body">
            <div className="time-item">
              <strong>
                {format(new Date(), common.dateFormats.interactiveTime)}
              </strong>
              <p>{convertSecondsToTime(interactiveTime?.clinicTime)}</p>
              <span>Clinic</span>
            </div>
            <div className="time-item">
              <strong>
                {format(new Date(), common.dateFormats.interactiveTime)}
              </strong>
              <p>{convertSecondsToTime(interactiveTime?.totalTime)}</p>
              <span>Total</span>
            </div>
          </div>
        </>,
      )}
    </div>
  );
};

CcmInteractiveTime.propTypes = {
  patientGuid: PropTypes.string.isRequired,
};

export default CcmInteractiveTime;
